<template>
    <div
        class="row scorecard-list-item pt-1 pb-1 mb-2"
        :style="{'background': index % 2 === 1 ? '#f3f5f7': '#fff'}"
    >
        <div class="col-2">
            <span>{{ scorecard.plantName }} / {{ scorecard.unitName }}</span>
        </div>
        <div class="col-2">
            <span v-if="scorecard.outageManager">{{ scorecard.outageManager }}</span>
            <span v-if="!scorecard.outageManager">N/A</span>
        </div>
        <div class="col-2">
            <span>{{ scorecard.outageId }}</span>
        </div>
        <div class="col-1">
            <span>{{ getPhaseTitle(scorecard.currentPhase) }}</span>
        </div>
        <div class="col-2">
            <span>
                <font-awesome-icon icon="calendar-alt" />
                {{ new Date(scorecard.startDate) | dateFormat('YYYY-MM-DD HH:mm') }}
            </span>
        </div>
        <div class="col-1">
            <span>
                <font-awesome-icon icon="clock" />
                {{ scorecard.duration }}
            </span>
        </div>
        <div class="col-1">
            <span>
                <font-awesome-icon icon="stopwatch" />
                {{ scorecard.daysToGo }}
            </span>
        </div>
        <div class="col-1">
            <span>{{ scorecard.totalScore.toFixed(0) }} %</span>

            <button
                type="button"
                class="btn btn-sm btn-primary float-right"
                @click="showDetails()"
                data-toggle="modal"
                data-target="#scorecardModal"
            >
                <font-awesome-icon icon="edit" />
            </button>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { TranslateResult } from 'vue-i18n';
import { PHASES } from '@/utils/scorecard-constants';
import { OutageScorecardItem } from '@/utils/interfaces';

@Component({
})
export default class ScorecardListItemComponent extends Vue {
    private phases = PHASES;

    @Prop()
    private scorecard!: OutageScorecardItem;

    @Prop()
    private index!: number;

    constructor() {
        super();
    }

    private showDetails(): void {
        this.$emit('details-clicked', this.scorecard);
    }

    private getBadgeClass(phase: number): string {
        switch (phase) {
            case this.phases.initiation:
                return 'initiation';
            case this.phases.scoping:
                return 'scoping';
            case this.phases.preparation:
                return 'preparation';
            case this.phases.implementation:
                return 'implementation';
        }
        return 'closeOut';
    }

    private getPhaseTitle(phase: number): TranslateResult {
        switch (phase) {
            case this.phases.initiation:
                return this.$t('initiation');
            case this.phases.scoping:
                return this.$t('scoping');
            case this.phases.preparation:
                return this.$t('preparation');
            case this.phases.implementation:
                return this.$t('implementation');
            case this.phases.closeOut:
                return this.$t('closeOut');
        }
        return '';
    }
}
</script>
<style lang="less">
@import url('./scorecard.less');
</style>
